import React from "react";
import clsx from "clsx";
import LocksCard from "../../LocksCard/LocksCard";

class RoomPresenterGeneral extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    //console.log("RoomPresenterGeneral", this.props);

    var tabClasses = clsx({
      active: this.props.active_tab == "general",
      "tab-pane": true,
    });

    return (
      <div className={tabClasses} id="general">
        {this.renderGeneralData()}
      </div>
    );
  }

  renderGeneralData() {
    if (this.props.housekeeping_view == true) {
      return (
        <div className="row">
          <div className="col">
            <p>
              <strong>{`${I18n.t("room_identifier")}: `}</strong>
              <span>{this.props.identifier}</span>
            </p>
            <p>
              <strong>{`${I18n.t("room_type")}: `}</strong>
              <span>{this.props.room_type}</span>
            </p>
            <p>
              <strong>{`${I18n.t("housekeeping_status")}: `} </strong>
              <span>{`${I18n.t(this.props.housekeeping_status)} `}</span>
            </p>
            <p style={{ marginBottom: "0px" }}>
              <strong>{`${I18n.t("occupancy_status")}: `} </strong>
              <span>{`${I18n.t(this.props.occupancy_status)} `}</span>
            </p>
          </div>
          <div className="col">
            <LocksCard room={this.props.room} />
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="row form-group">
            <div className="col-md-6">
              <label>{`${I18n.t("room_identifier")}*`}</label>{" "}
              <span
                className="ss-help help"
                title={I18n.t("identifier_helper_text")}
              ></span>
              <p> {this.props.room.identifier}</p>
            </div>
          </div>
          <hr />
          <div className="row form-group">
            <div className="col-md-6">
              <label>{`${I18n.t("pin_code")}`}</label>{" "}
              <span
                className="ss-help help"
                title={I18n.t("pin_code_helper_text")}
              ></span>
              <p>{this.props.pin_code}</p>
            </div>
          </div>
        </div>
      );
    }
  }
}
export default RoomPresenterGeneral;
